// @flow
import React from 'react';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import translations from 'shared/strings';
import AddToCalendarHOC, { SHARE_SITES } from '@ff/react-add-to-calendar-hoc';
import type Styles from 'shared/types';
import Button from './Button';
import Dropdown from './Dropdown';

type Props = {
  className: ?string,
  event: string,
  region: string
};

const CalendarButton = AddToCalendarHOC(Button, Dropdown);

export default function AddToCalendar(props: Props) {
  const {
    className, event, region = 'US'
  } = props;
  const c: Styles<typeof styles> = useStyles(props);

  const items = [SHARE_SITES.ICAL, SHARE_SITES.OUTLOOK];

  if (region !== 'CN') {
    // Add Google to top of list
    items.splice(0, 0, SHARE_SITES.GOOGLE);
  }

  return (
    <div className={cx(className, c.container)}>
      <CalendarButton
        event={event}
        items={items}
        buttonText={translations.ADD_TO_CALENDAR[region]}
        buttonProps={{ className: c.button }}
        dropdownProps={{ className: c.dropdown }}
      />
    </div>
  );
}

const styles = {
  button: {
    padding: '0',
    border: 'none',
    font: 'inherit',
    color: 'inherit',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    fontSize: '15px',
    '&:focus': {
      outline: 'none',
    }
  },
  container: {
    width: '100%',
    display: 'inline-flex',
    '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)',
  },
  dropdown: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    padding: '5px 0 5px 8px',
    boxShadow: '1px 3px 6px rgba(0, 0, 0, 0.15)',
    border: '1px solid #a8a8a8',
    backgroundColor: '#f7f7f7',
    textAlign: 'left',
    zIndex: '20',
    '& ul': {
      listStyle: 'none',
      padding: '0',
      margin: '0',
      '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)'
    },
    '& ul li': {
      width: '100%',
      marginLeft: '5px',
      marginRight: '10px'
    },
    '& a': {
      color: '#646569',
      textDecoration: 'none',
      lineHeight: '1.5'
    }
  }
};
const useStyles = createUseStyles(styles);
